/* Wave2Wear "Build Your Set" — pick a top + a bottom, choose sizes, add both to cart. */
(function () {
  var root = document.querySelector('[data-w2w-set]');
  if (!root) return;

  var currency = root.getAttribute('data-currency') || 'EUR';
  function fmt(cents) {
    try { return new Intl.NumberFormat(navigator.language || 'en', { style: 'currency', currency: currency }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + currency; }
  }
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function readJSON(group) { var el = root.querySelector('[data-set-json="' + group + '"]'); try { return JSON.parse(el.textContent); } catch (e) { return []; } }

  var data = { top: readJSON('top'), bottom: readJSON('bottom') };
  var state = { top: { product: null, variant: null }, bottom: { product: null, variant: null } };

  ['top', 'bottom'].forEach(function (group) {
    var strip = root.querySelector('[data-strip="' + group + '"]');
    if (!strip) return;
    data[group].forEach(function (p) {
      var card = document.createElement('button');
      card.type = 'button';
      card.className = 'w2w-set-card';
      card.innerHTML =
        '<img src="' + p.image + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' +
        '<span class="w2w-set-card__name">' + escapeHtml(p.title) + '</span>' +
        '<span class="w2w-set-card__price">' + fmt(p.price) + '</span>';
      card.addEventListener('click', function () { selectProduct(group, p, card); });
      strip.appendChild(card);
    });
  });

  function selectProduct(group, p, card) {
    state[group].product = p;
    state[group].variant = null;
    card.parentNode.querySelectorAll('.w2w-set-card').forEach(function (c) { c.classList.toggle('is-selected', c === card); });
    var sizes = root.querySelector('[data-sizes="' + group + '"]');
    sizes.innerHTML = '<span class="w2w-set__sizelabel">Size</span>';
    p.variants.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'w2w-set__size' + (v.available ? '' : ' is-soldout');
      b.textContent = v.size;
      if (!v.available) b.disabled = true;
      b.addEventListener('click', function () { selectSize(group, v, b); });
      sizes.appendChild(b);
    });
    sizes.hidden = false;
    updateSummary();
  }

  function selectSize(group, v, b) {
    state[group].variant = v;
    b.parentNode.querySelectorAll('.w2w-set__size').forEach(function (x) { x.classList.toggle('is-selected', x === b); });
    updateSummary();
  }

  function updateSummary() {
    var t = state.top, bt = state.bottom;
    root.querySelector('[data-pick="top"]').textContent = t.product ? (t.product.title + (t.variant ? ' · ' + t.variant.size : '')) : '—';
    root.querySelector('[data-pick="bottom"]').textContent = bt.product ? (bt.product.title + (bt.variant ? ' · ' + bt.variant.size : '')) : '—';
    var total = (t.variant ? t.variant.price : 0) + (bt.variant ? bt.variant.price : 0);
    root.querySelector('[data-total]').textContent = total ? fmt(total) : '—';
    root.querySelector('[data-add]').disabled = !(t.variant && bt.variant);
    root.querySelector('[data-summary]').hidden = !(t.product || bt.product);
  }

  root.querySelector('[data-add]').addEventListener('click', function () {
    var t = state.top.variant, bt = state.bottom.variant;
    if (!t || !bt) return;
    var btn = this, orig = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [
        { id: t.id, quantity: 1, properties: { _set: 'Wave2Wear set' } },
        { id: bt.id, quantity: 1, properties: { _set: 'Wave2Wear set' } }
      ] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; })
      .catch(function () { btn.disabled = false; btn.textContent = orig; alert('Sorry, the set could not be added. Please try again.'); });
  });
})();
